import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Person } from 'src/app/modules/entities/person';
import { PersonService } from 'src/app/modules/services/person.service';
import { environment } from 'src/environments/environment.development';
import { Location, isPlatformBrowser } from '@angular/common';
import { InteractionService } from 'src/app/modules/services/interaction.service';
import { Interaction } from 'src/app/modules/entities/interaction';
import { CookieService } from 'ngx-cookie-service';
import { url } from 'src/app/modules/util/constants';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private personService: PersonService, private messageService: MessageService,
    private location: Location, private interactionService: InteractionService, private cookies: CookieService, @Inject(PLATFORM_ID) private platformId: Object,
    private metaService: Meta, private titleService: Title) {
    //this.urlId = this.route.snapshot.paramMap.get('id');
    this.route.params.subscribe(params => {
      this.setupParams(params['id']);
    });
  }

  urlId: string | undefined;
  @Input() urlIdFromModal: string | undefined;
  person: Person | undefined = undefined;
  uploadLocation: string = environment.cfgApiBaseUrl + '/uploads/';
  thumbnailLocation: string = this.uploadLocation + '/thumbnails/';
  showGallery: boolean = false;
  activeIndex: number = 0;
  displayPasswordEdit: boolean = false;
  displayUsernameEdit: boolean = false;
  isAdmin: boolean = false;
  contactNumber: string = '';
  startX: number = 0;
  activityNumber: number = 3;

  ngOnInit(): void {
    if (!this.urlId) {
      this.urlId = this.urlIdFromModal;
      this.setUser();
    }
    if (isPlatformBrowser(this.platformId)) {
      if (sessionStorage.getItem('loggedUser'))
        this.contactNumber = this.cookies.get('contact').replaceAll("\"", "");
    }
  }

  setUser() {
    if (this.urlId) {
      let count: number = 0;
      let visitedProfiles: { [key: string]: string[] } = {};
      if (isPlatformBrowser(this.platformId)) {
        if (sessionStorage.getItem('loggedUser') !== this.urlId) {
          if (this.cookies.check('visitedProfiles')) {
            visitedProfiles = JSON.parse(this.cookies.get('visitedProfiles'));
            if (!visitedProfiles['visitedProfiles'].includes(this.urlId)) {
              visitedProfiles['visitedProfiles'].push(this.urlId);
              let expiration: Date = new Date(Date.now() + 7200000); // 2 horas
              this.cookies.set('visitedProfiles', JSON.stringify(visitedProfiles), { expires: expiration });
              count = 1;
            }
          } else {
            visitedProfiles['visitedProfiles'] = [this.urlId];
            let expiration: Date = new Date(Date.now() + 7200000); // 2 horas
            this.cookies.set('visitedProfiles', JSON.stringify(visitedProfiles), { expires: expiration });
            count = 1;
          }
          if (sessionStorage.getItem('loggedUser') === 'admin') {
            this.isAdmin = true;
            count = 0;
          }
        }
      }
      this.personService.getFullProfile(this.urlId, count).subscribe({
        next: response => {
          if (response.status === 'success') {
            let personTemp = response.data as Person;
            //if (personTemp.visible === 1) {
              this.person = personTemp;
              if (!this.urlIdFromModal) {
                //let profileTitle = 'Perfil de ' + this.person.name + ' ' + this.person.user.userName + ' | MuyComplacientes';
                let profileTitle = this.person.name + ' ' + this.person.user.userName + ', Perfil Escort en ' + this.person.locality.name + ', ' + this.person.city.name;
                let profilePicture = this.thumbnailLocation;
                profilePicture += this.person.mediaContent?.find(media => media.isProfile === 1)?.fileName;
                this.titleService.setTitle(profileTitle);
                this.metaService.removeTag("name='description'");
                this.metaService.removeTag("property='og:title'");
                this.metaService.removeTag("property='og:description'");
                this.metaService.removeTag("property='og:image'");
                this.metaService.removeTag("name='twitter:title'");
                this.metaService.removeTag("name='twitter:description'");
                this.metaService.removeTag("name='twitter:'");
                this.metaService.updateTag({ name: 'description', content: this.summarize(this.person.description) });
                this.metaService.updateTag({ property: 'og:title', content: profileTitle });
                this.metaService.updateTag({ property: 'og:description', content: this.summarize(this.person.description) });
                this.metaService.updateTag({ property: 'og:image', content: profilePicture });
                this.metaService.updateTag({ name: 'twitter:title', content: profileTitle });
                this.metaService.updateTag({ name: 'twitter:description', content: this.summarize(this.person.description) });
                this.metaService.updateTag({ name: 'twitter:image', content: profilePicture });
              }
              if (this.person.activities)
                this.activityNumber = this.person.activities.length;
            /*} else {
              if (isPlatformBrowser(this.platformId)) {
                if (sessionStorage.getItem('loggedUser') === this.urlId || sessionStorage.getItem('loggedUser') === 'admin') {
                  this.person = personTemp;
                } else {
                  if (this.cookies.check('navigationCity')) {
                    this.router.navigate([url['lista-perfiles'] + '/' + this.cookies.get('navigationCity')]);
                  } else {
                    this.router.navigate([url['lista-perfiles']]);
                  }
                }
              }
            }*/
          } else {
            this.router.navigate([url['404']], { skipLocationChange: true });
          }
        }
      });
    }
  }

  setupParams(urlId: string) {
    this.urlId = urlId;
    this.setUser();
  }

  editPassword() {
    this.displayPasswordEdit = true;
  }

  editUsername() {
    this.displayUsernameEdit = true;
  }

  imageClick(index: number): void {
    this.activeIndex = index;
    this.showGallery = true;
  }

  isSameAsLoggedUser(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return sessionStorage.getItem('loggedUser') === this.urlId || sessionStorage.getItem('loggedUser') === 'admin';
    } else {
      return false;
    }
  }

  getIcon(servicePlace: string): string {
    switch (servicePlace) {
      case 'Hoteles':
        return 'pi pi-building'
      case 'Hoteles/Moteles':
        return 'pi pi-building'
      case 'A domicilio':
        return 'pi pi-car'
      case 'Lugar propio':
        return 'pi pi-home'
      default:
        return ''
    }
  }

  summarize(description: string) {
    return description.length > 310 ? description.substring(0, 310).replace(/[\n\r]+/g, " ") + ' (...)' : description.replace(/[\n\r]+/g, " ");
  }

  contactWhatsapp() {
    if (!this.isSameAsLoggedUser()) {
      //contar contacto
      let interaction: Interaction = {
        type: 'whatsapp',
        person: this.person?.url_id
      }
      this.interactionService.postInteraction(interaction).subscribe();
      //redirigir
      let currentUrl = environment.appBaseRef + this.location.prepareExternalUrl(this.location.path());
      let contactUrl = 'https://api.whatsapp.com/send?phone=57' + this.person?.user.userName
        + '&text=Hola%2C+vi+tu+perfil+en+*MuyComplacientes*+y+me+llama+la+atención.+' + currentUrl;
      window.open(contactUrl);
    } else {
      this.messageService.add({
        detail: 'No te puedes escribir a ti',
        severity: 'warn',
      });
    }
  }

  contact() {
    if (!this.isSameAsLoggedUser()) {
      //contar contacto
      let interaction: Interaction = {
        type: 'phone',
        person: this.person?.url_id
      }
      this.interactionService.postInteraction(interaction).subscribe();
      //redirigir
      let contactUrl = 'tel:' + this.person?.user.userName
      window.open(contactUrl);
    } else {
      this.messageService.add({
        detail: 'No te puedes llamar a ti',
        severity: 'warn',
      });
    }
  }

  contactUs() {
    let contactUrl = 'https://api.whatsapp.com/send?phone=' + this.contactNumber;
    window.open(contactUrl);
  }

  upgrade() {
    let contactUrl = 'https://api.whatsapp.com/send?phone=' + this.contactNumber +'&text=Hola%2C+estoy+interesada+en+mejorar+mi+suscripción.';
    window.open(contactUrl);
  }

  goToSubscriptionDetail() {
    this.router.navigate([url['detalle-suscripcion'], this.person!.url_id]);
  }

  canEdit(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      let logged: boolean = sessionStorage.getItem('auth') === null ? false : true;
      let loggedUser: string = String(sessionStorage.getItem('loggedUser'));
      return logged && (loggedUser === this.urlId || loggedUser === 'admin');
    } else {
      return false;
    }
  }

  editProfile() {
    this.router.navigate([url['editar-perfil'], this.urlId]);
  }

  goToDetail() {
    this.router.navigate([url['detalle-perfil'], this.urlId]);
  }

  editMedia() {
    this.router.navigate([url['editar-media'], this.urlId]);
  }

  goToCreateActivity() {
    this.router.navigate([url['crear-actividad'], this.urlId]);
  }

  isNew(person: Person): boolean {
    return new Date(person.user.registrationDate) > this.addDays(new Date(), -30);
  }

  isActive(person: Person): boolean {
    return new Date(person.user.lastLogin) > this.addDays(new Date(), -7);
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  arrowKeyDown(event: KeyboardEvent) {
    if (event.code === 'ArrowLeft') {
      this.changeImage(-1);
    } else if (event.code === 'ArrowRight') {
      this.changeImage(1);
    }
  }

  changeImage(direction: number) {
    if (direction < 0) {
      if (this.activeIndex > 0) {
        this.activeIndex--;
      } else {
        this.activeIndex = this.person!.mediaContent!.length - 1;
      }
    } else if (direction > 0) {
      if (this.activeIndex < this.person!.mediaContent!.length - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    }
  }

  touchStart(event: TouchEvent) {
    if (event.targetTouches[0])
      this.startX = event.targetTouches[0].clientX;
  }

  touchEnd(event: TouchEvent) {
    if (event.changedTouches[0]) {
      let difference = event.changedTouches[0].clientX - this.startX;
      if (difference > 50)
        this.changeImage(-1);
      else if (difference < -50)
        this.changeImage(1);
    }
  }

}
